// plugins/globalClickHandler.client.js
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const router = useRouter();

  document.addEventListener("click", (e) => {
    // home_ico, bi → SPA 라우팅으로 home 이동
    if (e.target.closest(".home_ico") || e.target.closest(".bi")) {
      e.preventDefault();
      navigateTo("/home");
      return;
    }

    // back_ico → Vue Router의 back 사용
    if (e.target.closest(".back_ico")) {
      e.preventDefault();
      
      const backPath = router.options.history.state.back;
      console.log("⬅️ 뒤로갈 경로:", backPath);
      
      if (backPath) {
        // back() 대신 명시적으로 그 경로로 push
        navigateTo(backPath);
      } else {
        navigateTo("/home");
      }
      return;

      // 라우팅 히스토리가 있으면 뒤로가기, 없으면 home으로
      // if (window.history.length > 1) {
      //   console.log('라우팅 히스토리 존재, 뒤로가기 실행');
      //   router.back();
      // } else {
      //   navigateTo("/home");
      // }
      // return;
    }
  });
});